import {
  BadgeCheck,
  Calendar,
  ChevronRight,
  ClipboardList,
  Mail,
  Search,
  Shield,
  UserPlus,
  Users,
  Zap,
} from 'lucide-react';

export default function ViewMembres() {
  return (
    <div className='grid md:grid-cols-2 gap-10 items-start demo-view-enter'>
      {/* Left */}
      <div className='space-y-6'>
        <div className='inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/20 px-3 py-1.5 rounded-full'>
          <Zap className='w-3.5 h-3.5 text-emerald-500 dark:text-emerald-400' />
          <span className='text-xs font-bold text-emerald-600 dark:text-emerald-400'>
            Fini les tableaux Excel & WhatsApp
          </span>
        </div>

        <div>
          <h3 className='text-2xl font-black text-slate-900 dark:text-white mb-2'>Gérez vos membres, simplement</h3>
          <p className='text-slate-500 dark:text-slate-400 text-sm leading-relaxed'>
            Ajoutez des membres, renseignez les numéros de licence et exportez vos listes en 1 clic.
          </p>
        </div>

        {/* Search bar */}
        <div className='bg-slate-100 border border-slate-200 dark:bg-slate-800/80 dark:border-slate-700 rounded-2xl p-3 flex items-center gap-3'>
          <Search className='w-4 h-4 text-slate-400 shrink-0' />
          <span className='text-slate-500 dark:text-slate-300 text-sm flex-1'>Rechercher un membre…</span>
          <span className='bg-blue-600 text-white text-xs px-3 py-1.5 rounded-xl font-bold'>Rechercher</span>
        </div>

        {/* Quick actions */}
        <div className='grid grid-cols-2 gap-3'>
          <div className='bg-white border border-slate-200 dark:bg-slate-900/60 dark:border-slate-800 rounded-2xl p-4'>
            <div className='flex items-center gap-2 text-xs font-black text-slate-600 dark:text-slate-300 mb-2'>
              <UserPlus className='w-4 h-4 text-blue-600 dark:text-blue-400' />
              Ajouter un membre
            </div>
            <p className='text-[11px] text-slate-500 dark:text-slate-400 leading-relaxed'>
              Invitation email ou ajout direct (nom + licence).
            </p>
          </div>

          <div className='bg-white border border-slate-200 dark:bg-slate-900/60 dark:border-slate-800 rounded-2xl p-4'>
            <div className='flex items-center gap-2 text-xs font-black text-slate-600 dark:text-slate-300 mb-2'>
              <ClipboardList className='w-4 h-4 text-emerald-600 dark:text-emerald-400' />
              Informations licence
            </div>
            <p className='text-[11px] text-slate-500 dark:text-slate-400 leading-relaxed'>
              Numéro de licence renseigné, catégorie d'âge et classification.
            </p>
          </div>
        </div>

        {/* Platform stats */}
        <div className='grid grid-cols-3 gap-3 pt-2'>
          {[
            { v: '86', l: 'membres', c: 'text-blue-600 dark:text-blue-400' },
            { v: '79', l: 'licences renseignées', c: 'text-emerald-600 dark:text-emerald-400' },
            { v: '1', l: 'club', c: 'text-amber-600 dark:text-amber-400' },
          ].map(({ v, l, c }) => (
            <div
              key={l}
              className='bg-slate-50 border border-slate-200 dark:bg-slate-900/60 dark:border-slate-800 rounded-2xl p-4 text-center'
            >
              <p className={`text-xl font-black ${c}`}>{v}</p>
              <p className='text-[10px] text-slate-500 mt-0.5'>{l}</p>
            </div>
          ))}
        </div>

        <div className='flex items-start gap-2 text-xs text-slate-500 bg-slate-50 border border-slate-200 dark:bg-slate-900/50 dark:border-slate-800 rounded-xl px-4 py-3'>
          <Shield className='w-3.5 h-3.5 shrink-0 mt-0.5' />
          <span>Le numéro de licence est renseigné par chaque joueur.</span>
        </div>
      </div>

      {/* Right — member cards */}
      <div className='space-y-3'>
        {/* Card 1: verified */}
        <div className='bg-blue-50/60 border border-blue-200/60 dark:bg-slate-800/60 dark:border-blue-500/30 rounded-2xl p-5 hover:border-blue-400 dark:hover:border-blue-500/60 transition cursor-pointer'>
          <div className='flex items-start gap-3'>
            <div className='w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center font-black text-white text-sm shadow-lg shadow-blue-600/30 dark:shadow-blue-900/40 shrink-0'>
              MB
            </div>
            <div className='flex-1 min-w-0'>
              <p className='font-bold text-slate-900 dark:text-white text-sm truncate'>
                Marc Bernard
                <span className='ml-2 text-slate-500 dark:text-slate-400 font-normal text-xs'>(Capitaine)</span>
              </p>
              <p className='text-xs text-slate-500 dark:text-slate-400 mt-0.5'>
                Licence #06901456 · Doublette/Triplette
              </p>
            </div>
            <BadgeCheck className='w-5 h-5 text-emerald-500 dark:text-emerald-400 shrink-0' />
          </div>

          <div className='mt-4 flex items-center justify-between'>
            <div className='flex items-center gap-2 text-[10px] font-bold text-slate-500 dark:text-slate-400'>
              <Calendar className='w-3 h-3' />2 concours ce mois-ci
            </div>
            <span className='bg-emerald-500/10 border border-emerald-500/20 text-emerald-600 dark:text-emerald-400 text-[9px] font-black px-2 py-0.5 rounded-md uppercase tracking-wider'>
              Licence renseignée
            </span>
          </div>
        </div>

        {/* Card 2: missing info */}
        <div className='bg-white border border-slate-200 dark:bg-slate-800/50 dark:border-slate-700 rounded-2xl p-5 hover:border-slate-300 dark:hover:border-slate-600 transition cursor-pointer'>
          <div className='flex items-start gap-3'>
            <div className='w-10 h-10 bg-slate-200 border border-slate-300 dark:bg-slate-700 dark:border-slate-600 rounded-full flex items-center justify-center shrink-0'>
              <Users className='w-4 h-4 text-slate-400 dark:text-slate-500' />
            </div>
            <div className='flex-1 min-w-0'>
              <p className='font-bold text-slate-900 dark:text-white text-sm truncate'>Sophie Martin</p>
              <p className='text-xs text-slate-500 dark:text-slate-400 mt-0.5'>
                Licence à renseigner · Invitation envoyée
              </p>
            </div>
            <ChevronRight className='w-5 h-5 text-slate-400 dark:text-slate-600' />
          </div>
          <div className='mt-4 flex items-center gap-2 text-xs text-blue-600 dark:text-blue-300'>
            <Mail className='w-3.5 h-3.5' />
            <span>Relancer</span>
          </div>
        </div>

        <p className='text-center text-slate-500 dark:text-slate-600 text-xs pt-1'>+ 84 autres membres</p>
      </div>
    </div>
  );
}
